import { render, staticRenderFns } from "./DatePickerPage.vue?vue&type=template&id=3f8cfcc0&scoped=true&"
import script from "./DatePickerPage.vue?vue&type=script&lang=js&"
export * from "./DatePickerPage.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerPage.vue?vue&type=style&index=0&id=3f8cfcc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8cfcc0",
  null
  
)

export default component.exports